/**
 * Single source of truth for which document extensions the in-app viewer can
 * render inline. DocumentViewerModal renders these; "tap to view" affordances
 * (e.g. maintenance report files) gate on `isViewableDocument` so they hide for
 * files the viewer would only show its unsupported-type fallback for.
 */
export const isPdfUrl = urlOrName => /\.pdf(?:$|\?)/i.test(urlOrName || '');
export const isDocxUrl = urlOrName => /\.docx(?:$|\?)/i.test(urlOrName || '');
export const isImageUrl = urlOrName =>
  /\.(png|jpe?g|gif|webp|bmp|svg)(?:$|\?)/i.test(urlOrName || '');

export const isViewableDocument = name => isPdfUrl(name) || isDocxUrl(name) || isImageUrl(name);

export default isViewableDocument;
